export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/sidebar-logo.png?69c8ab64fd1cfda09f22fc646c162ca4";